import '@babel/polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'

import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vuelidate from 'vuelidate'

import VueTheMask from 'vue-the-mask'

import '@fortawesome/fontawesome-free/css/all.css'

import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import i18n from './language/i18n'

import DisableAutocomplete from '@/core/util/vue-disable-autocomplete'

import './assets/css/base.scss'
import DateUtils, { DateConstants } from '@/core/util/date-utils'

import CKEditor from '@ckeditor/ckeditor5-vue'

Vue.use(BootstrapVue)
Vue.use(VueLoading, {
  color: '#3B94F1',
  isFullPage: true,
  loader: 'dots',
  backgroundColor: '#ffffff',
  width: 128,
  height: 128,
  opacity: 0.5,
  zIndex: 9999
})

Vue.use(Vuelidate)

Vue.use(VueTheMask)

Vue.use(DisableAutocomplete)

Vue.use(CKEditor)

Vue.config.productionTip = false

Vue.filter('formatDatetime', function (value) {
  if (value) {
    return DateUtils.formatDate(value, DateConstants.DD_MM_YYYY_HH_MM)
  }
  return value
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return DateUtils.formatDate(value, DateConstants.DD_MM_YYYY)
  }
  return value
})
/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
